import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3049dfc9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "send-code-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oio_input = _resolveComponent("oio-input")!
  const _component_oio_button = _resolveComponent("oio-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_oio_input, {
      style: {"width":"30%"},
      value: _ctx.code,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.code) = $event)),
      placeholder: "请输入验证码",
      onChange: _ctx.onInput
    }, null, 8, ["value", "onChange"]),
    _createVNode(_component_oio_button, {
      type: "primary",
      onClick: _ctx.onSend,
      loading: _ctx.loading,
      disabled: _ctx.disabled,
      style: {"width":"110px"}
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.sendStatusStr), 1)
      ]),
      _: 1
    }, 8, ["onClick", "loading", "disabled"])
  ]))
}